<div class="title">{{ title }}</div>
<div class="download-error-batch">
    <button pButton class="mt-11 p-element p-ripple p-button p-component" (click)="downloadErrorReport()">
        <div class="icon-wrapper"><span class="icon icon-download icon-invert"></span> </div> Download
    </button>
</div>
<div class="table-wrapper">
    <app-dynamic-table [tableData]="{ data: (batchErrors$ | async), cols: columnTable }"
        [isLoading]="batchErrorLoading$ | async"></app-dynamic-table>
</div>